import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=2e8342e6&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"
import style0 from "./productList.vue?vue&type=style&index=0&id=2e8342e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8342e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8342e6')) {
      api.createRecord('2e8342e6', component.options)
    } else {
      api.reload('2e8342e6', component.options)
    }
    module.hot.accept("./productList.vue?vue&type=template&id=2e8342e6&scoped=true", function () {
      api.rerender('2e8342e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/property/productList.vue"
export default component.exports